import { render, staticRenderFns } from "./econsent-details.vue?vue&type=template&id=222c540a&scoped=true&"
import script from "./econsent-details.vue?vue&type=script&lang=js&"
export * from "./econsent-details.vue?vue&type=script&lang=js&"
import style0 from "./econsent-details.vue?vue&type=style&index=0&id=222c540a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c540a",
  null
  
)

component.options.__file = "econsent-details.vue"
export default component.exports